"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SFCActionBar',
  props: {
    scale: {
      type: Number
    }
  },
  methods: {
    scaleIn: function scaleIn() {
      this.$emit('update:scale', this.scale + 10);
    },
    scaleOut: function scaleOut() {
      if (this.scale <= 0) {
        return;
      }
      this.$emit('update:scale', this.scale - 10);
    }
  }
};